// extracted by mini-css-extract-plugin
export default {"body":"styles_body__F9pM6","productName":"styles_productName__HUIAb"};